export const Modal = (props) => {
	const close = (e) => {
		e.stopPropagation();
		props.close();
	};

	const stop = (e) => {
		e.stopPropagation();
	};

	return (
		<div
			className={"rbr-modal " + (!!props.open ? "rbr-modal-open" : "")}
			onClick={close}
		>
			<div className="rbr-modal-content uk-open" onClick={stop}>
				{props.children}
			</div>
		</div>
	);
};
